import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FC } from 'react';

import styles from './IssueCard.module.scss';

interface IssueCardSubTitleProps {
  text: string;
  tooltip?: string;
}

const IssueCardSubTitle: FC<IssueCardSubTitleProps> = ({ text, tooltip }) => {
  if (tooltip) {
    return (
      <div className={styles.subTitle}>
        {text}{' '}
        <Tooltip title={tooltip}>
          <InfoCircleOutlined />
        </Tooltip>
      </div>
    );
  }
  return <div className={styles.subTitle}>{text}</div>;
};

export default IssueCardSubTitle;
